var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-left"},[_vm._v(_vm._s('إظهار صفحة ' + _vm.data.current_page + ' من ' + _vm.data.last_page + ' و إجمالى عدد البيانات' + ' ' + _vm.data.total))])
}
var staticRenderFns = []

export { render, staticRenderFns }